export default class ContactBlock {
  constructor(el) {
    this.el = el;
    this.form = null;
    this.openId = null;
    this.init();
    this.initEvents();
  }

  init() {}

  initEvents() {    
    var contactTiles = this.el.querySelectorAll(".contact-block-tile");
    contactTiles.forEach((contactTile) => {
      var link = contactTile.querySelector(".contact-block-index-link");

      if(link){       
        link.removeEventListener("click", (e) => this.handleOpen(e));
        link.addEventListener("click", (e) => this.handleOpen(e));
      }      
    });

    var btnsClose = this.el.querySelectorAll(".btn-close");
    btnsClose.forEach((btnClose) => {
      if(btnClose){
        btnClose.removeEventListener("click", (e) => this.handleClose(e));
        btnClose.addEventListener("click", (e) => this.handleClose(e));
      }
    });
  }

  handleOpen(e) {
    e.preventDefault();
    var contactform = this.el.querySelector("#contactblockform_" + this.openId);
    var contactformContainer = this.el.querySelector("#contactblockform__container_" + this.openId);
    if (this.openId && contactform && contactformContainer) {
      contactform.style.display = "none";
      contactformContainer.style.display = "none";
    }

    this.openId = e.target.getAttribute("href");
    contactform = this.el.querySelector("#contactblockform_" + this.openId);
    contactformContainer = this.el.querySelector("#contactblockform__container_" + this.openId);
    if (contactform != null && contactformContainer != null) {
      contactform.style.display = "inline";
      contactformContainer.style.display = "flex";
    } 
  }

  handleClose(e) {
    e.preventDefault();
    var contactform = this.el.querySelector("#contactblockform_" + this.openId);
    var contactformContainer = this.el.querySelector("#contactblockform__container_" + this.openId);
    if (contactform != null && contactformContainer != null) {
      contactform.style.display = "none";
      contactformContainer.style.display = "none";
    }

    this.openId = null;
  }
}
